import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ["liveRegion"];

  /**
   * Handles cart update events and announces the new count to screen readers.
   * @param {Event} event
   */
  #onCartUpdate = event => {
    const customEvent = /** @type {CustomEvent<{ resource?: { item_count?: number } }>} */ (event);
    const cartCount = customEvent.detail?.resource?.item_count;
    if (cartCount === undefined) {
      return;
    }

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }
}

if (!customElements.get("header-actions")) {
  customElements.define("header-actions", HeaderActions);
}
